module.exports = __webpack_public_path__ + "static/media/instagram.9aadc3e6.svg";